import { createPriceRule, ICreatePriceRuleRequestBody } from 'src/api/createPriceRule/createPriceRule';
import { IRuleCalculationFields } from 'src/types/priceRules';

const buildCreatePriceRequest = (
  external_system_id: string,
  payload: ICreatePriceRuleRequestBody,
  priceSchemeId: string,
) => {
  return createPriceRule(
    {
      external_system_id,
      price_band_id: undefined,
      adjustment: payload.adjustment,
      rounding: payload.rounding,
    },
    priceSchemeId,
  );
};

const createPriceRules = async (data: IRuleCalculationFields, priceSchemeId: string) => {
  const { entities, ...payload } = data;

  const channelRuleRequests = entities.map((externalSystem) =>
    buildCreatePriceRequest(externalSystem, payload, priceSchemeId),
  );

  const settled = await Promise.allSettled(channelRuleRequests);
  const results = settled.map((result, index) => ({ result, externalSystemId: entities.at(index) }));

  const failures = results
    .filter(({ result }) => result.status === 'rejected')
    .map(({ externalSystemId }) => externalSystemId);
  if (failures.length > 0) {
    return {
      error: true,
      failures,
    };
  }

  return {
    error: false,
    failures: [],
  };
};

export default createPriceRules;
